const SubBrandCard = ({ data, onEdit }) => {
    // Helper function to convert hex to rgba
    const hexToRgba = (hex, opacity) => {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result 
            ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${opacity})`
            : `rgba(255, 255, 255, ${opacity})`;
    };
    
    return (
        <div 
            className="rounded-xl p-4"
            style={{ 
                backgroundColor: data.hex_code_bg || '#1A1B1E',
                color: data.hex_code_text || '#FFFFFF'
            }}>
            <div className="flex justify-between items-start pb-3">
                <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-white rounded-full">
                        {data.image ? (
                            <img 
                                src={data.image} 
                                alt={data.name} 
                                className="w-full h-full rounded-full object-cover"
                            />
                        ) : (
                            <div className="w-full h-full bg-zinc-300 rounded-full" />
                        )}
                    </div>
                    <div>
                        <h4 className="font-medium">{data.name}</h4>
                        <p className="text-xs">ID: {data.id}</p>
                    </div>
                </div>
                <button 
                    onClick={() => onEdit && onEdit(data)}
                    className="p-3 border rounded-full hover:bg-zinc-700/20 transition-colors"
                    style={{ borderColor: data.hex_code_text || '#FFFFFF' }}
                >
                    <svg className="w-4 h-4" fill="none" stroke={data.hex_code_text || '#FFFFFF'} viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                </button>
            </div>

            {data.description &&
                <p className="text-sm pb-3">
                    {data.description}
                </p>
            }

            <div className="pb-3">
                <div className="grid grid-cols-4 gap-3">
                    <label className="flex items-center cursor-default">
                        <input 
                            type="checkbox" 
                            className="h-4 w-4 accent-indigo-700 pointer-events-none" 
                            checked={data?.is_pin} 
                            readOnly 
                        />
                        <span className="ml-1.5 text-xs">ONLY PIN</span>
                    </label>
                    <label className="flex items-center cursor-default">
                        <input 
                            type="checkbox" 
                            className="h-4 w-4 accent-indigo-700 rounded-lg pointer-events-none" 
                            checked={data?.is_wallet} 
                            readOnly 
                        />
                        <span className="ml-1.5 text-xs">WALLET</span>
                    </label>
                    <label className="flex items-center cursor-default">
                        <input 
                            type="checkbox" 
                            className="h-4 w-4 accent-indigo-700 pointer-events-none" 
                            checked={data?.excluded?.is_referral} 
                            readOnly 
                        />
                        <span className="ml-1.5 text-xs">REFERRAL</span>
                    </label>
                    <label className="flex items-center cursor-default">
                        <input 
                            type="checkbox" 
                            className="h-4 w-4 accent-indigo-700 rounded-lg pointer-events-none" 
                            checked={data?.excluded?.is_activation_promotion} 
                            readOnly 
                        />
                        <span className="ml-1.5 text-xs">PROMO</span>
                    </label>
                </div>
            </div>

            <div className="flex justify-start pb-3">
                <span className={`px-4 py-1.5 text-xs rounded-full ${
                    data.is_active 
                        ? 'bg-green-950 text-green-500 border border-green-500' 
                        : 'bg-red-950 text-red-500 border border-red-500'
                    }`}>
                    {data.is_active ? 'ACTIVE' : 'INACTIVE'}
                </span>
            </div>
            
            <div className="space-y-2">
                {data?.sub_brand_vendors.map(vendor => (
                    <div 
                        key={vendor.id} 
                        className="grid grid-cols-4 px-3 py-2.5 rounded-lg transition-all text-xs border"
                        style={{ 
                            backgroundColor: vendor.is_active ? '#FFFFFF' : (data.hex_code_bg || '#1A1B1E'),
                            borderColor: vendor.is_active ? 'transparent' : (data.hex_code_text || '#FFFFFF'),
                            color: vendor.is_active ? '#000000' : (data.hex_code_text || '#FFFFFF')
                        }}
                    >
                        <div>
                            <p className="text-xs border-b pb-1.5 mb-1.5">VENDOR</p>
                            <div className="flex items-center space-x-1.5">
                                <p className="font-medium">
                                    {vendor.name}
                                </p>
                                {vendor.is_active && (
                                    <span className="w-1.5 h-1.5 bg-green-500 rounded-full"></span>
                                )}
                            </div>
                        </div>
                        <div>
                            <p className="text-xs border-b pb-1.5 mb-1.5">TYPE</p>
                            <p>{vendor.type}</p>
                        </div>
                        <div className="text-center">
                            <p className="text-xs border-b pb-1.5 mb-1.5">MIN</p>
                            <p>₹{vendor.min}</p>
                        </div>
                        <div className="text-right">
                            <p className="text-xs border-b pb-1.5 mb-1.5">MAX</p>
                            <p>₹{vendor.max}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SubBrandCard;